const trackedControllers = new Set();

let originalFetch = null;
let installed = false;

function getInputSignal(input, init) {
  if (init && init.signal) return init.signal;
  if (typeof Request !== "undefined" && input instanceof Request) return input.signal || null;
  if (input && typeof input === "object" && "signal" in input) return input.signal || null;
  return null;
}

function bindAbort(sourceSignal, controller) {
  if (!sourceSignal || typeof sourceSignal.addEventListener !== "function") {
    return () => {};
  }
  if (sourceSignal.aborted) {
    try {
      controller.abort(sourceSignal.reason);
    } catch (e) {
      controller.abort();
    }
    return () => {};
  }

  const onAbort = () => {
    try {
      controller.abort(sourceSignal.reason);
    } catch (e) {
      controller.abort();
    }
  };
  sourceSignal.addEventListener("abort", onAbort, { once: true });
  return () => {
    try {
      sourceSignal.removeEventListener("abort", onAbort);
    } catch (e) {
      /* ignore */
    }
  };
}

export function installFetchTracker() {
  if (installed) return;
  if (typeof window === "undefined" || typeof window.fetch !== "function") return;

  originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const controller = new AbortController();
    trackedControllers.add(controller);

    const sourceSignal = getInputSignal(input, init);
    const unbindAbort = bindAbort(sourceSignal, controller);
    const nextInit = Object.assign({}, init || {}, { signal: controller.signal });

    return originalFetch(input, nextInit).finally(() => {
      unbindAbort();
      trackedControllers.delete(controller);
    });
  };

  installed = true;
}

export function abortTrackedFetches() {
  for (const controller of Array.from(trackedControllers)) {
    try {
      controller.abort();
    } catch (e) {
      /* ignore */
    }
  }
  trackedControllers.clear();
}
